var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M10.142 12.7987V5.2013L16.8068 9.00017L10.142 12.7987ZM24.9671 2.81076C24.6739 1.70434 23.8098 0.83308 22.7127 0.537388C20.7241 0 12.75 0 12.75 0C12.75 0 4.77593 0 2.78731 0.537388C1.69019 0.83308 0.826078 1.70434 0.532853 2.81076C0 4.81606 0 9 0 9C0 9 0 13.1839 0.532853 15.1893C0.826078 16.2957 1.69019 17.1669 2.78731 17.4627C4.77593 18 12.75 18 12.75 18C12.75 18 20.7241 18 22.7127 17.4627C23.8098 17.1669 24.6739 16.2957 24.9671 15.1893C25.5 13.1839 25.5 9 25.5 9C25.5 9 25.5 4.81606 24.9671 2.81076Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.1fc28b0aafcf850e88582e58589d907d.svg";
export { ForwardRef as ReactComponent };